import { browserSessionStore } from '@tassat/utility';
import axios from 'axios';
import jwt from 'jsonwebtoken';
import React from 'react';

import { EXPORT_SERVER_TIMEOUT } from 'Lib/constant';
import { ExportsContext, exportsStateInitialState } from 'Lib/context/exportsContext';
import { timeoutPromise } from 'Lib/TimeOutPromise';
import { useAppSelector } from 'Reducers/store/hooks';
import { getUser } from 'Selectors/common';
import { IExportsContext, IExportsState } from 'SharedComponents/hooks/useExports';

interface IExportHandlerProps {
    children?: React.ReactNode;
}

function ExportHandler (props: IExportHandlerProps) {
    const { children } = props;

    const user = useAppSelector(getUser);
    const [ exportsContext, setExportsContext ] = React.useState<IExportsState>(exportsStateInitialState);
    const exportsContextValue = React.useMemo((): IExportsContext => ({
        ...exportsContext,
        setExportsContext
    }), [exportsContext]);

    React.useEffect(() => {
        if (exportsContext.totalChunks > 0 && exportsContext.totalChunks > exportsContext.chunkCounter) {
            startDownload();
        } else if (exportsContext.totalChunks > 0) {
            setExportsContext(exportsStateInitialState);
        }
    }, [ exportsContext, setExportsContext ]);

    const startDownload = async() => {
        try {
            if (user.Username) {
                const id_token = browserSessionStore.getItem('id_token');
                const userid = browserSessionStore.getItem('userid');
                const decodedJWT = jwt.decode(id_token);
                const jwtUsername = decodedJWT['username'];

                await timeoutPromise(EXPORT_SERVER_TIMEOUT, axios.get('/server-check/'));
                const opts = Buffer.from(JSON.stringify({ assets: exportsContext.opts.assets }))
                    .toString('base64');

                let exportUrl = `history/${exportsContext.RecordType}?`;
                exportUrl += `${exportsContext.filterQuery}&PageNo=${exportsContext.chunkCounter + 1}&opts=${opts}`;
                exportUrl += '&Export=true';
                if (jwtUsername === user.Username){
                    const newWindow = window.open(exportUrl, '_blank');
                    newWindow.addEventListener('beforeunload', () => {
                        setExportsContext({
                            ...exportsContext,
                            chunkCounter: exportsContext.chunkCounter + 1
                        });
                    });
                    newWindow.document.body.innerHTML = 'Export download is currently in progress. Please do not close this window until the download completes.';
                    newWindow.document.title = 'Download in progress...';
                } else {
                    const newWindow = window.open('', '_blank');
                    newWindow.document.body.innerHTML = 'Export download cannot be completed.';
                    newWindow.document.title = 'Error in download...';
                }
            }
        } catch (er) {
            setExportsContext({
                ...exportsStateInitialState,
                exportError: 'Server is busy processing an export.'
            });
        }
    };

    React.useEffect(() => {
        if (exportsContext.exportError !== '') {
            setTimeout(() => {
                setExportsContext(exportsStateInitialState);
            }, 5000);
        }
    }, [exportsContext.exportError]);

    return (
        <ExportsContext.Provider value={exportsContextValue}>
            {children}
        </ExportsContext.Provider>
    );
}
export default ExportHandler;